<template>
  <section
    :class="{
      'portable-text-content-card': true,
    }"
  >
    <ContentCard
      v-if="contentCard"
      v-bind="contentCard"
    />
  </section>
</template>

<script lang="ts" setup>
import ContentCard from './ContentCard.vue';
import type { PortableTextContentCard } from '~/sanity/types';
defineProps<PortableTextContentCard>();
</script>

<style></style>
